import { paddingLarge, paddingXXL } from "src/styles/spacing";
import { useSafeArea } from "src/swsh-native";
import usePhotoDetailDim from "./usePhotoDetailDim";

const usePhotoDetailHeaderDimensions = () => {
	const dim = usePhotoDetailDim();
	const safeArea = useSafeArea();
	return {
		width: dim.width - (safeArea.left + safeArea.right),
		height: safeArea.top + paddingLarge + 36 + paddingXXL,
		// height = top of screen<->top of Pill + Pill height + bottom of Pill<->top of photo
	};
};

export default usePhotoDetailHeaderDimensions;
